import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUM = "5582999393287";
const WHATSAPP_DISPLAY = "82 99939-3287";
const DEFAULT_MSG = encodeURIComponent("Olá! Vim pelo site da Parceria Certa Imobiliária e gostaria de mais informações.");

export const FloatingWhatsApp = () => {
  return (
    <motion.a
      href={`https://wa.me/${WHATSAPP_NUM}?text=${DEFAULT_MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.5, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 1.2, ease: [0.2, 0.8, 0.2, 1] }}
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-[80] group"
      data-testid="floating-whatsapp-btn"
      aria-label="Conversar no WhatsApp"
    >
      <div className="relative flex items-center bg-[#25D366] text-white pl-4 pr-5 py-3 md:py-3.5 shadow-2xl shadow-[#25D366]/30 wa-shine overflow-hidden gold-pulse">
        <div className="flex items-center gap-3">
          <div className="relative z-10 flex items-center justify-center w-7 h-7">
            <MessageCircle size={22} strokeWidth={2} fill="white" />
          </div>
          <div className="hidden sm:flex flex-col leading-tight relative z-10">
            <span className="text-[0.6rem] tracking-[0.2em] uppercase opacity-80">Fale Conosco</span>
            <span className="font-semibold text-[0.88rem] tracking-wide">{WHATSAPP_DISPLAY}</span>
          </div>
        </div>
      </div>
    </motion.a>
  );
};
